import type { IHttpClient } from '@/services/api/HttpClient';
import { BrokerHttpService } from '@/services/api/services/broker';
import { ChoicesApiHttpService } from '@/services/api/services/choicesApi';
import { ChoicesSimpleHttpService } from '@/services/api/services/choicesSimple';
import { ClientHttpService } from '@/services/api/services/client';
import { CompaniesHttpService } from '@/services/api/services/companies';
import { ContractHttpService } from '@/services/api/services/contract';
import { DistributionHttpService } from '@/services/api/services/distribution';
import { FeaturesHttpService } from '@/services/api/services/features';
import { FilesHttpService } from '@/services/api/services/files';
import { GlobalHttpService } from '@/services/api/services/global';
import { MailTemplateHttpService } from '@/services/api/services/mailTemplate';
import { PreviousInsuranceHttpService } from '@/services/api/services/previousInsurance';
import { PrintHttpService } from '@/services/api/services/print';
import { ProfileHttpService } from '@/services/api/services/profile';
import { QuotesHttpService } from '@/services/api/services/quotes';
import { TariffsHttpService } from '@/services/api/services/tariffs';
import { EVBHttpService } from '@/services/api/services/eVB';
import { VehicleDataHttpService } from '@/services/api/services/vehicleData';
import { InputMappingHttpService } from '@/services/api/services/inputMapping';
import { ProfessionsHttpService } from '@/services/api/services/professions';
import { ComplexSelectHttpService } from '@/services/api/services/complexSelect';
import { AIHttpService } from '@/services/api/services/ai';
import { VersicherungsangabenHttpService } from '@/services/api/services/versicherungsangaben';
import { VorgabenHttpService } from '@/services/api/services/vorgaben';

export class HttpServiceProvider {
  private readonly httpClient: IHttpClient;

  public readonly broker: BrokerHttpService;

  public readonly choicesSimple: ChoicesSimpleHttpService;

  public readonly choicesApi: ChoicesApiHttpService;

  public readonly client: ClientHttpService;

  public readonly companies: CompaniesHttpService;

  public readonly contract: ContractHttpService;

  public readonly distribution: DistributionHttpService;

  public readonly features: FeaturesHttpService;

  public readonly files: FilesHttpService;

  public readonly global: GlobalHttpService;

  public readonly mailTemplates: MailTemplateHttpService;

  public readonly previousInsurance: PreviousInsuranceHttpService;

  public readonly print: PrintHttpService;

  public readonly profile: ProfileHttpService;

  public readonly quotes: QuotesHttpService;

  public readonly tariffs: TariffsHttpService;

  public readonly eVBService: EVBHttpService;

  public readonly vehicleData: VehicleDataHttpService;

  public readonly inputMapping: InputMappingHttpService;

  public readonly professions: ProfessionsHttpService;

  public readonly complexSelect: ComplexSelectHttpService;

  public readonly ai: AIHttpService;

  public readonly versicherungsangaben: VersicherungsangabenHttpService;

  public readonly vorgaben: VorgabenHttpService;

  constructor(httpClient: IHttpClient) {
    this.httpClient = httpClient;

    this.broker = new BrokerHttpService(httpClient);
    this.choicesSimple = new ChoicesSimpleHttpService(httpClient);
    this.choicesApi = new ChoicesApiHttpService(httpClient);
    this.client = new ClientHttpService(httpClient);
    this.companies = new CompaniesHttpService(httpClient);
    this.contract = new ContractHttpService(httpClient);
    this.distribution = new DistributionHttpService(httpClient);
    this.features = new FeaturesHttpService(httpClient);
    this.files = new FilesHttpService(httpClient);
    this.global = new GlobalHttpService(httpClient);
    this.mailTemplates = new MailTemplateHttpService(httpClient);
    this.previousInsurance = new PreviousInsuranceHttpService(httpClient);
    this.print = new PrintHttpService(httpClient);
    this.profile = new ProfileHttpService(httpClient);
    this.quotes = new QuotesHttpService(httpClient);
    this.tariffs = new TariffsHttpService(httpClient);
    this.eVBService = new EVBHttpService(httpClient);
    this.vehicleData = new VehicleDataHttpService(httpClient);
    this.inputMapping = new InputMappingHttpService(httpClient);
    this.professions = new ProfessionsHttpService(httpClient);
    this.complexSelect = new ComplexSelectHttpService(httpClient);
    this.ai = new AIHttpService(httpClient);
    this.versicherungsangaben = new VersicherungsangabenHttpService(httpClient);
    this.vorgaben = new VorgabenHttpService(httpClient);
  }

  public getBaseUrl(): string {
    return this.httpClient.getBaseURL();
  }

  static getPwUrl(): string {
    return import.meta.env.VITE_APP_PW_API_PATH || '';
  }
}
